import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { Toaster } from 'sonner';
import SEO from './components/SEO';
import ChatBot from './components/ChatBot';
import ScrollToTop from './components/ScrollToTop';
import { AdminAuthProvider } from './context/AdminAuthContext';

// Public pages
import HomePage from './pages/HomePage';
import CommercialServices from './pages/CommercialServices';
import ResidentialServices from './pages/ResidentialServices';
import InsuranceClaims from './pages/InsuranceClaims';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

// Admin
import AdminLogin from './pages/AdminLogin';
import AdminShell from './pages/admin/AdminShell';
import AdminOverview from './pages/admin/AdminOverview';
import AdminLeads from './pages/admin/AdminLeads';
import AdminApplications from './pages/admin/AdminApplications';
import AdminContacts from './pages/admin/AdminContacts';
import AdminTeam from './pages/admin/AdminTeam';
import AdminSettings from './pages/admin/AdminSettings';

function PublicLayout({ children }) {
  return <>{children}<ChatBot /></>;
}

function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <SEO />
          <Routes>
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/commercial-services" element={<PublicLayout><CommercialServices /></PublicLayout>} />
            <Route path="/residential-services" element={<PublicLayout><ResidentialServices /></PublicLayout>} />
            <Route path="/insurance-claims" element={<PublicLayout><InsuranceClaims /></PublicLayout>} />
            <Route path="/careers" element={<PublicLayout><Careers /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />

            {/* Blog & Gallery removed — pages temporarily disabled.
                Old URLs redirect to the homepage so any external links don't 404. */}
            <Route path="/blog" element={<Navigate to="/" replace />} />
            <Route path="/blog/:slug" element={<Navigate to="/" replace />} />
            <Route path="/gallery" element={<Navigate to="/" replace />} />
            <Route path="/gallery/:slug" element={<Navigate to="/" replace />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminShell />}>
              <Route index element={<AdminOverview />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="applications" element={<AdminApplications />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          <Toaster position="top-center" />
        </div>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;
